import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, Card, DatePicker } from 'antd';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import { getAllSubscription } from '../../feature/subscription/subscriptionSlice';
import { ArrowLeft } from 'lucide-react';
import { addDaycare, getDaycare } from '../../feature/dayCare/dayCareSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getCmsData, getCmsDataObject } from '../../constant/Constatnt';
import { addPrivacy, getPrivacy } from '../../feature/cms/PrivacySlice';
import { addTerms } from '../../feature/cms/TermSlice';
import { addAboutus } from '../../feature/cms/AboutSlice';

function AddCmsData() {
    const [descriptions, setDescriptions] = useState(null)
    const { cmdfor, type } = useParams()

    const { allSubscriptionList } = useSelector((state) => state.subscriptions);
    const { actionLoader } = useSelector((state) => state.privacies);
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    console.log("allSubscriptionList", allSubscriptionList)


    const onFinish = async () => {
        const body = {
            for: cmdfor,
            description: descriptions
        };

        let action;

        if (type === "privacy-policy") {
            action = addPrivacy(body);
        } else if (type === "terms-conditions") {
            action = addTerms(body);
        } else {
            action = addAboutus(body);
        }

        const resultAction = await dispatch(action);

        if (addPrivacy.fulfilled.match(resultAction) ||
            addTerms.fulfilled.match(resultAction) ||
            addAboutus.fulfilled.match(resultAction)
        ) {
            form.resetFields();
            navigate('/dashboard/cms');
        } else {
            console.error("Error creating CMS");
        }
    };



    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    return (
        <section>
            <Card title={
                <Space>
                    <ArrowLeft onClick={() => navigate(-1)} />
                    <h4 className='cms_add_title'>Add {type}</h4>
                </Space>
            }>
                <Form
                    form={form}
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    {/* <Form.Item
                        name="for"
                        label="Select Type"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Type",
                            },
                        ]}>
                        <Select placeholder='Select Type '>
                            {getCmsData.map((item) => (
                                <Select.Option key={item} value={item}>{item}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item> */}
                    <Form.Item name="description"
                        label="Description"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Description!",
                            },
                        ]}>
                        <CKEditor
                            editor={ClassicEditor}
                            data={descriptions}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setDescriptions(data)
                            }}
                            config={{
                                placeholder: "Write here..."
                            }}

                        />

                    </Form.Item>
                    <Form.Item  >
                        <div className='submit_btn'>
                            <Space>
                                <Button type="primary" loading={actionLoader} htmlType="submit">
                                    Submit
                                </Button>
                                <Button danger htmlType="button" onClick={handleCancel}>
                                    Reset
                                </Button>
                            </Space>
                        </div>
                    </Form.Item>
                </Form>
            </Card>
        </section>
    );
}



export default AddCmsData